import { BlockStack, InlineStack, Tag, Text } from '@shopify/polaris'

import { idToGid } from '../common/helpers'
import { AdvancedDashboardFilter } from './advanced-filters'

export const AdvancedDashboardFilterLabels = ({ filter }: { filter: AdvancedDashboardFilter }) => {
  if (!filter.isFiltered) return null

  return (
    <BlockStack gap="200">
      {!!filter.products.length && (
        <InlineStack gap="200" blockAlign="center">
          <Text as="strong">Selected products:</Text>{' '}
          {filter.products.map((product) => (
            <Tag key={product.restId} onRemove={() => filter.onProductRemove(product.id)}>
              {product.title}
            </Tag>
          ))}
        </InlineStack>
      )}
      {!!filter.productVariants.length && (
        <InlineStack gap="200" blockAlign="center">
          <Text as="strong">Selected product variants:</Text>{' '}
          {filter.productVariants.map((variant) => (
            <Tag key={variant.restId} onRemove={() => filter.onProductVariantRemove(variant.id)}>
              {variant.productTitle}: {variant.variantTitle}
            </Tag>
          ))}
        </InlineStack>
      )}
      {!!filter.sellingPlanIds.length && (
        <InlineStack gap="200" blockAlign="center">
          <Text as="strong">Selected selling plans:</Text>{' '}
          {filter.sellingPlanIds.map((planId) => (
            <Tag key={planId}>{filter.sellingPlanNames[idToGid(planId, 'SellingPlan')]}</Tag>
          ))}
        </InlineStack>
      )}
    </BlockStack>
  )
}
